import React from "react";
import { ModalService } from "@sportal/cdk";

import { MobileModal } from "../../../../../../components/modal";
import { ToggleActionsButton } from "../../../../../settings/tabs/devicesTab/tableComponents/toggleActionsButton";
import { MobileModalListBody } from "../../../../../settings/tabs/devicesTab/tableComponents";

export const ScheduleActionsToggle = ({ header = "", menuItems }) => {
  const openMobileModal = () => {
    ModalService.show((modal) => ({
      dialog: (
        <ScheduleActionsModal
          modal={modal}
          header={header}
          menuItems={menuItems}
        />
      ),
    }))
      .then(() => {})
      .catch(() => {});
  };

  return <ToggleActionsButton onClick={openMobileModal} />;
};

const ScheduleActionsModal = ({ modal, header, menuItems }) => {
  return (
    <MobileModal
      className={"schedule-actions"}
      modal={modal}
      header={header}
      content={<MobileModalListBody items={menuItems} />}
    />
  );
};
